export default __webpack_public_path__ + "static/media/services_truck_parking.1e776d8e.svg";